import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DienstleistungsModuleBeschreibung } from '../../domain/model/dienstleistungsmodulebeschreibung.model';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class DienstleistungsmoduleService {

    private http = inject(HttpClient);

    public listDienstleistungsModuleBeschreibung(): Observable<DienstleistungsModuleBeschreibung[]> {
        return this.http.get<DienstleistungsModuleBeschreibung[]>(environment.API_URL + '/dienstleistungsmodule');
    }

    public getDienstleistungsModuleBeschreibung(id: number): Observable<DienstleistungsModuleBeschreibung> {
        return this.http.get<DienstleistungsModuleBeschreibung>(environment.API_URL + '/dienstleistungsmodule/' + id);
    }

    public updateDienstleistungsModuleBeschreibung(module: DienstleistungsModuleBeschreibung): Observable<DienstleistungsModuleBeschreibung> {
        return this.http.put<DienstleistungsModuleBeschreibung>(environment.API_URL + '/admin/dienstleistungsmodule/' + module.id, module);
    }
}
